(() => {
 'use strict';
 function eligible(s){return !!(s.available&&s.cartKnown&&!s.inCart&&s.below&&!s.up&&!s.dismissed&&!s.busy);}
 if(typeof window==='undefined'){module.exports={eligible};return;}
 const panel=document.getElementById('gx-product-reminder'),context=document.getElementById('gx-assistant-context');if(!panel||!context)return;
 let cfg;try{cfg=JSON.parse(context.textContent);}catch{return;}if(!cfg.product)return;
 const reduced=matchMedia('(prefers-reduced-motion:reduce)'),action=panel.querySelector('[data-gx-return]');
 let dismissed=false,up=false,lastY=scrollY,cart=null,cartAt=0,pending=false,retryAt=0,frame=0,chatButton=null,cartEpoch=0;
 const submit=()=>document.querySelector('product-info .product-form__submit[name="add"]');
 function priority(active){
  const value=String(active);if(panel.dataset.gxPriority===value)return;
  panel.dataset.gxPriority=value;
  document.dispatchEvent(new CustomEvent('gx:product-reminder-priority',{detail:{active}}));
 }
 function hide(){if(!panel.hidden)panel.hidden=true;priority(false);}
 function chatOpen(){
  if(!chatButton?.isConnected){
   const host=document.querySelector('shopify-chat'),roots=host?.shadowRoot?[host.shadowRoot]:[];
   for(let i=0;i<roots.length&&i<20;i++){
    const found=roots[i].querySelector('button[part~="activator"]');if(found){chatButton=found;break;}
    roots[i].querySelectorAll('*').forEach(el=>{if(el.shadowRoot)roots.push(el.shadowRoot);});
   }
  }return chatButton?.getAttribute('aria-expanded')==='true';
 }
 function busy(){return document.hidden||chatOpen()||!!document.querySelector('.drawer.active,dialog[open],.menu-drawer-container[open],.mobile-facets__disclosure[open],.gx-department-nav details[open],input:not([type="radio"]):not([type="checkbox"]):focus,textarea:focus,select:focus');}
 function refresh(){
  const source=document.querySelector('product-info [id^="price-"] .price');
  const price=source?.querySelector(source.classList.contains('price--on-sale')?'.price__sale .price-item--sale':'.price__regular .price-item--regular');
  if(price)panel.querySelector('[data-gx-reminder-price]').textContent=price.textContent.trim();
  const options=document.querySelector('product-info variant-selects'),names=(cfg.product.options||[]).map(o=>o.name.toLowerCase());
  action.textContent=options?(names.some(n=>n.includes('size'))?'Choose size':names.some(n=>n.includes('color')||n.includes('colour'))?'Choose colour':'Choose options'):'Back to Add to cart';
  panel.querySelector('[data-gx-reminder-message]').textContent=options?"Still considering this item? Choose your options and add it to your cart when you're ready.":"Still considering this item? Add it to your cart when you're ready.";
 }
 function schedule(){if(!frame)frame=requestAnimationFrame(()=>{frame=0;tick();});}
 async function checkCart(){
  if(pending||Date.now()<retryAt||document.hidden)return;
  pending=true;const epoch=cartEpoch;
  try{
   const response=await fetch(`${cfg.root||'/'}cart.js`,{headers:{Accept:'application/json'},signal:AbortSignal.timeout(4500)});
   if(!response.ok)throw Error('cart');const data=await response.json();if(!Array.isArray(data.items))throw Error('cart');if(epoch===cartEpoch){cart=data;cartAt=Date.now();retryAt=0;}
  }catch{if(epoch===cartEpoch){cart=null;retryAt=Date.now()+30000;hide();}}finally{pending=false;if(epoch!==cartEpoch)checkCart();schedule();}
 }
 function tick(){
  const button=submit(),marker=document.querySelector('#judgeme_product_reviews,.jdgm-review-widget,product-recommendations.related-products');
  // Reaching the review boundary wins immediately, including while a finger stays on screen.
  const below=!!marker&&marker.getBoundingClientRect().top<innerHeight;
  const available=cfg.product.available&&!!button&&!button.disabled&&button.getAttribute('aria-disabled')!=='true';
  const base={available,below,up,dismissed,busy:busy()};
  if(!eligible({...base,cartKnown:true,inCart:false})){hide();return;}
  if(!cart||Date.now()-cartAt>15000){
   panel.hidden=true;priority(Date.now()>=retryAt);checkCart();return;
  }
  if(eligible({...base,cartKnown:true,inCart:cart.items.some(i=>String(i.product_id)===String(cfg.product.id))})){
   priority(true);if(panel.hidden)refresh();panel.hidden=false;if(panel.dataset.gxState!=='shown')panel.dataset.gxState='shown';
  }else hide();
 }
 panel.querySelector('[data-gx-reminder-close]').addEventListener('click',()=>{dismissed=true;hide();});
 action.addEventListener('click',()=>{
  hide();up=true;
  const options=document.querySelector('product-info variant-selects'),target=options||submit();
  const focus=options?.querySelector('select:not(:disabled),input:not([type="hidden"]):not(:disabled),button:not(:disabled)')||target;
  target?.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'center'});
  setTimeout(()=>focus?.isConnected&&focus.focus({preventScroll:true}),reduced.matches?0:500);
 });
 window.addEventListener('scroll',()=>{
  const y=scrollY,delta=y-lastY;if(delta<-2){up=true;hide();}else if(delta>2)up=false;lastY=y;schedule();
 },{passive:true});
 function invalidate(){cartEpoch++;cart=null;cartAt=0;hide();checkCart();schedule();}
 if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,invalidate);
 document.addEventListener('cart:updated',invalidate);
 window.addEventListener('pageshow',event=>{if(event.persisted){dismissed=false;up=false;lastY=scrollY;invalidate();}});
 document.addEventListener('visibilitychange',()=>{if(document.hidden)hide();else invalidate();});
 window.addEventListener('pagehide',hide);
 if(typeof IntersectionObserver!=='undefined'){
  const observer=new IntersectionObserver(schedule);
  const marker=document.querySelector('#judgeme_product_reviews,.jdgm-review-widget,product-recommendations.related-products');if(marker)observer.observe(marker);
 }
 checkCart();schedule();setInterval(tick,500);
})();
